import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  authUserData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  openLoginFlow: false,
  openSignupFlow: false,
  openVerifyEmail: false,
  openLookingForFlow: false,
  openPropertySubCategoryFlow: false,
  openScheduleVisitFlow: false,
  openAcknowledgementFlow: false,
  openAgentLoginFlow: false,
  openAgentSignupFlow: false,
  agentSignUpData: {
    items: {},
    agentSignUpStep: 1,
  },
  uploadIdProofData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  uploadAddressProofData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  uploadTaxProofData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  homepagePropertyListData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  homePropertyCategoriesByType: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  homePropertySubCategory: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  agentListData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  propertyLatestDealData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  testimonialsList: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  userDetailsData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  homepagePropertyfilterData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
};

export const loginSlice = createSlice({
  name: "loginUserData",
  initialState,
  reducers: {
    setAuthUserData: (state, action) => {
      state.authUserData.items = action.payload;
    },
    setAuthUserDataLoading: (state, action) => {
      state.authUserData.loading = action.payload;
    },
    setAuthUserDataError: (state, action) => {
      state.authUserData.error = action.payload;
      state.authUserData.items = [];
    },
    setOpenSignupFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openSignupFlow = false;
        } else {
          state.openSignupFlow = action.payload;
        }
      } else {
        state.openSignupFlow = action.payload;
      }
    },
    setOpenLoginFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openLoginFlow = false;
        } else {
          state.openLoginFlow = action.payload;
        }
      } else {
        state.openLoginFlow = action.payload;
      }
    },

    setOpenVerifyEmailFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openVerifyEmail = false;
        } else {
          state.openVerifyEmail = action.payload;
        }
      } else {
        state.openVerifyEmail = action.payload;
      }
    },

    setOpenLookingForFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openLookingForFlow = false;
        } else {
          state.openLookingForFlow = action.payload;
        }
      } else {
        state.openLookingForFlow = action.payload;
      }
    },
    setOpenPropertySubCategoryFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openPropertySubCategoryFlow = false;
        } else {
          state.openPropertySubCategoryFlow = action.payload;
        }
      } else {
        state.openPropertySubCategoryFlow = action.payload;
      }
    },
    setOpenScheduleVisitFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openScheduleVisitFlow = false;
        } else {
          state.openScheduleVisitFlow = action.payload;
        }
      } else {
        state.openScheduleVisitFlow = action.payload;
      }
    },
    setOpenAcknowledgementFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openAcknowledgementFlow = false;
        } else {
          state.openAcknowledgementFlow = action.payload;
        }
      } else {
        state.openAcknowledgementFlow = action.payload;
      }
    },
    setOpenAgentSignupFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("agent_token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openAgentSignupFlow = false;
        } else {
          state.openAgentSignupFlow = action.payload;
        }
      } else {
        state.openAgentSignupFlow = action.payload;
      }
    },
    setOpenAgentLoginFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("agent_token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openAgentLoginFlow = false;
        } else {
          state.openAgentLoginFlow = action.payload;
        }
      } else {
        state.openAgentLoginFlow = action.payload;
      }
    },
    setAgentSignupData: (state, action) => {
      state.agentSignUpData.items = action.payload;
    },
    setAgentSignupStepCount: (state, action) => {
      state.agentSignUpData.agentSignUpStep = action.payload;
    },
    setAgentIdProof: (state, action) => {
      state.uploadIdProofData.items = action.payload;
    },
    setAgentAddressProof: (state, action) => {
      state.uploadAddressProofData.items = action.payload;
    },
    setAgentTaxProof: (state, action) => {
      state.uploadTaxProofData.items = action.payload;
    },
    setHomepagePropertyList: (state, action) => {
      state.homepagePropertyListData.items = action.payload;
    },
    setHomepagePropertyListLoading: (state, action) => {
      state.homepagePropertyListData.loading = action.payload;
    },
    setHomepagePropertyListError: (state, action) => {
      state.homepagePropertyListData.error = action.payload;
      state.homepagePropertyListData.items = [];
    },
    setHomePropertyCategoryByTypeData: (state, action) => {
      state.homePropertyCategoriesByType.items = action.payload;
    },
    setHomePropertyCategoryByTypeDataLoading: (state, action) => {
      state.homePropertyCategoriesByType.loading = action.payload;
    },
    setHomePropertyCategoryByTypeDataError: (state, action) => {
      state.homePropertyCategoriesByType.error = action.payload;
      state.homePropertyCategoriesByType.items = [];
    },
    setAgentList: (state, action) => {
      state.agentListData.items = action.payload;
    },
    setAgentListLoading: (state, action) => {
      state.agentListData.loading = action.payload;
    },
    setAgentListError: (state, action) => {
      state.agentListData.error = action.payload;
      state.agentListData.items = [];
    },
    setPropertyLatestDeal: (state, action) => {
      state.propertyLatestDealData.items = action.payload;
    },
    setPropertyLatestDealLoading: (state, action) => {
      state.propertyLatestDealData.loading = action.payload;
    },
    setPropertyLatestDealError: (state, action) => {
      state.propertyLatestDealData.error = action.payload;
      state.propertyLatestDealData.items = [];
    },
    setTestimonialData: (state, action) => {
      state.testimonialsList.items = action.payload;
    },
    setTestimonialDataLoading: (state, action) => {
      state.testimonialsList.loading = action.payload;
    },
    setTestimonialDataError: (state, action) => {
      state.testimonialsList.error = action.payload;
      state.testimonialsList.items = [];
    },
    setUserDetailsList: (state, action) => {
      state.userDetailsData.items = action.payload;
    },
    setUserDetailsListLoading: (state, action) => {
      state.userDetailsData.loading = action.payload;
    },
    setUserDetailsListError: (state, action) => {
      state.userDetailsData.error = action.payload;
      state.userDetailsData.items = [];
    },
    setHomePropertySubCategoryData: (state, action) => {
      state.homePropertySubCategory.items = action.payload;
    },
    setHomePropertySubCategoryDataLoading: (state, action) => {
      state.homePropertySubCategory.loading = action.payload;
    },
    setHomePropertySubCategoryDataError: (state, action) => {
      state.homePropertySubCategory.error = action.payload;
      state.homePropertySubCategory.items = [];
    },
    setPropertyFilterList: (state, action) => {
      state.homepagePropertyfilterData.items = action.payload;
    },
    setPropertyFilterListLoading: (state, action) => {
      state.homepagePropertyfilterData.loading = action.payload;
    },
    setPropertyFilterListError: (state, action) => {
      state.homepagePropertyfilterData.error = action.payload;
      state.homepagePropertyfilterData.items = [];
    },
    // testimonialsList
  },
});

// Action creators are generated for each case reducer function
export const {
  setAuthUserData,
  setAuthUserDataLoading,
  setAuthUserDataError,
  setOpenLoginFlow,
  setOpenSignupFlow,
  setOpenVerifyEmailFlow,
  setOpenLookingForFlow,
  setOpenPropertySubCategoryFlow,
  setOpenScheduleVisitFlow,
  setOpenAcknowledgementFlow,
  setOpenAgentSignupFlow,
  setOpenAgentLoginFlow,
  setAgentSignupData,
  setAgentSignupStepCount,
  setAgentAddressProof,
  setAgentTaxProof,
  setAgentIdProof,
  setHomepagePropertyList,
  setHomepagePropertyListLoading,
  setHomepagePropertyListError,
  setAgentList,
  setAgentListError,
  setAgentListLoading,
  setPropertyLatestDeal,
  setPropertyLatestDealLoading,
  setPropertyLatestDealError,
  setTestimonialData,
  setTestimonialDataLoading,
  setTestimonialDataError,
  setUserDetailsList,
  setUserDetailsListLoading,
  setUserDetailsListError,
  setHomePropertyCategoryByTypeData,
  setHomePropertyCategoryByTypeDataLoading,
  setHomePropertyCategoryByTypeDataError,
  setHomePropertySubCategoryData,
  setHomePropertySubCategoryDataLoading,
  setHomePropertySubCategoryDataError,
  setPropertyFilterList,
  setPropertyFilterListLoading,
  setPropertyFilterListError
} = loginSlice.actions;

export default loginSlice.reducer;

export const loginItemsSelector = (state) => state.loginUserData;
